module.exports = __webpack_public_path__ + "img/h5img9.748c3157.png";